export default "__VITE_ASSET__Cf7OMX4b__"